var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.188,
    height: 15.75,
    viewBox: "0 0 15.188 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009cde;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.406 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.313,2.813h9.281V3.938H7.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.406,3.375a2.25,2.25,0,1,0,2.25-2.25,2.25,2.25,0,0,0-2.25,2.25ZM3.656,2.25A1.125,1.125,0,1,1,2.531,3.375,1.125,1.125,0,0,1,3.656,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.313,8.438h9.281V9.563H7.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.656,11.25A2.25,2.25,0,1,0,1.406,9a2.25,2.25,0,0,0,2.25,2.25Zm0-3.375A1.125,1.125,0,1,1,2.531,9,1.125,1.125,0,0,1,3.656,7.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.313,14.063h9.281v1.125H7.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.656,16.875a2.25,2.25,0,1,0-2.25-2.25,2.25,2.25,0,0,0,2.25,2.25Zm0-3.375a1.125,1.125,0,1,1-1.125,1.125A1.125,1.125,0,0,1,3.656,13.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.bf2d988e.svg";
export { ForwardRef as ReactComponent };